module.exports = __webpack_public_path__ + "img/109041.4836e40d.png";